export const getCompetitionImage = (logo) => {
  return `${process.env.REACT_APP_STATIC_URL}${logo}`
}
